
import React from 'react'
import PropTypes from 'prop-types'
import { myListingsIconUrl } from '../../utils/staticAssets'

class ArrowIcon extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      arrow: undefined
    }

    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount () {
    if (this.isSelected()) {
      this.setState({ arrow: '_down' })
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.currentSelected !== this.props.currentSelected) {
      this.setState({ arrow: '_down' })
    }
  }

  handleClick () {
    const arrow = this.state.arrow === '_down' ? '-up' : '_down'
    this.setState({ arrow: arrow })
    this.props.onClick()
  }

  isSelected () {
    return this.props.currentSelected === this.props.title
  }

  render () {
    const { arrow } = this.state
    const arrowType = arrow || '_down'
    const opacity = this.isSelected() ? '1' : '0.4'

    return (
      <a onClick={this.handleClick} style={{ cursor: 'pointer', opacity: opacity }}>
        <img
          src={myListingsIconUrl(`arrow${arrowType}.svg`)}
          alt=''
          className='ml-6 w-16'
        />
      </a>
    )
  }
}

ArrowIcon.propTypes = {
  onClick: PropTypes.func,
  currentSelected: PropTypes.string
}

export default ArrowIcon
